module.exports = __webpack_public_path__ + "img/yu.b179a987.png";